import Vue from 'vue'
import Vuex from 'vuex'
import customRate from './modules/custom-rate'
import otherIncome from './modules/other-income'
import otherExpense from './modules/other-expense'
import chemical from './modules/chemical'
import fertilizer from './modules/fertilizer'
import seed from './modules/seed'
import irrigation from './modules/irrigation'
import crop from './modules/crop'
import convertUnit from './modules/convert-unit'
import commodity from './modules/commodity'
import company from './modules/company'
import user from './modules/user'
import notification from './modules/notification'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    chemical,
    commodity,
    company,
    convertUnit,
    crop,
    customRate,
    otherIncome,
    otherExpense,
    fertilizer,
    seed,
    irrigation,
    user,
    notification
  }
})
